module.exports = __webpack_public_path__ + "static/img/GW.8aa08cd2.svg";